import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useFloating, offset, flip, shift, autoUpdate, useInteractions, useHover, useRole, useDismiss, FloatingPortal, arrow } from '@floating-ui/react';
import { useState, useRef } from 'react';
import { cn } from '../../utils';
export function Tooltip({ content, children, className, placement = 'top', disabled = false, }) {
    const [isOpen, setIsOpen] = useState(false);
    const arrowRef = useRef(null);
    const { refs, floatingStyles, context, middlewareData, placement: actualPlacement } = useFloating({
        open: isOpen && !disabled,
        onOpenChange: setIsOpen,
        placement,
        middleware: [
            offset(8),
            flip(),
            shift({ padding: 8 }),
            arrow({ element: arrowRef }),
        ],
        whileElementsMounted: autoUpdate,
    });
    const hover = useHover(context, {
        delay: {
            open: 200,
            close: 0,
        },
        enabled: !disabled,
    });
    const dismiss = useDismiss(context);
    const role = useRole(context);
    const { getReferenceProps, getFloatingProps } = useInteractions([
        hover,
        dismiss,
        role,
    ]);
    const getArrowStyles = () => {
        const side = actualPlacement.split('-')[0];
        const baseStyle = {
            position: 'absolute',
            width: '6px',
            height: '6px',
            background: '#454140',
            transform: 'rotate(45deg)',
        };
        const offset = '-3px';
        switch (side) {
            case 'top':
                return {
                    ...baseStyle,
                    bottom: offset,
                    left: middlewareData.arrow?.x,
                };
            case 'bottom':
                return {
                    ...baseStyle,
                    top: offset,
                    left: middlewareData.arrow?.x,
                };
            default:
                return {
                    ...baseStyle,
                    left: middlewareData.arrow?.x,
                    top: middlewareData.arrow?.y,
                };
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { ref: refs.setReference, ...getReferenceProps(), children: children }), _jsx(FloatingPortal, { children: isOpen && (_jsxs("div", { ref: refs.setFloating, style: floatingStyles, className: cn('z-50 rounded-control bg-fg px-stack py-stack-tight text-caption text-fg-inverse shadow-md font-light max-w-80 sm:max-w-96', className), ...getFloatingProps(), children: [content, _jsx("div", { ref: arrowRef, style: getArrowStyles(), className: "pointer-events-none" })] })) })] }));
}
